import { AutogenModelDrsDeductHist, AutogenRowDrsDeductHist } from "./autogen/AutogenModelDrsDeductHist";

export class ModelDrsDeductHist extends AutogenModelDrsDeductHist<RowDrsDeductHist> {
	constructor() {
		super(RowDrsDeductHist);
	}
}

export class RowDrsDeductHist extends AutogenRowDrsDeductHist {
}